// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"727":"npm.canvg","773":"npm.dompurify"}[chunkId] || chunkId) + "." + {"727":"8e54a94bf5f60a9c9520","773":"3583c96bdcb5610ab06e","945":"bfcce02489954844d202"}[chunkId] + ".chunk.js";
};